<template>
  <a-button type="primary" :disabled="initData.isEdit" @click="showModal"
    >新增获取方式</a-button
  >
  <a-modal
    v-model:visible="visible"
    :title="title"
    @ok="handleOk"
    cancelText="取消"
    okText="确定"
    v-if="visible"
    :okButtonProps="{
      disabled:
        disabledRadio1 && disabledRadio2 && disabledRadio3 && isEdit === 'add'
    }"
  >
    <a-radio-group
      @change="langCodeChange"
      style="margin-bottom: 14px !important;"
      v-model:value="subLangCode"
      v-if="initData?.langDic && initData?.langDic?.length"
    >
      <a-radio-button
        v-for="item in initData.langDic"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </a-radio-button>
    </a-radio-group>
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="获取方式类型" name="type">
        <a-radio-group
          v-model:value="formState.type"
          :disabled="isEdit === 'view' || isEdit === 'edit' || notDefaultLang"
        >
          <a-radio :value="1" :disabled="disabledRadio1">每日登录</a-radio>
          <a-radio :value="2" :disabled="disabledRadio2">积分兑换</a-radio>
          <a-radio :value="3" :disabled="disabledRadio3">邮件订阅</a-radio>
        </a-radio-group>
      </a-form-item>
      <span v-for="(item, index) in formState.langs" :key="index">
        <a-form-item
          label="名称"
          :name="['langs', index, 'name']"
          :rules="rules.name"
          v-if="item.langCode === subLangCode"
        >
          <a-input
            v-model:value="item.name"
            placeholder="请输入"
            show-count
            :maxlength="25"
            :disabled="isEdit === 'view'"
          />
        </a-form-item>
        <a-form-item
          label="描述"
          :name="['langs', index, 'description']"
          :rules="rules.description"
          v-if="item.langCode === subLangCode"
        >
          <a-input
            v-model:value="item.description"
            placeholder="请输入"
            show-count
            :maxlength="60"
            :disabled="isEdit === 'view'"
          />
        </a-form-item>
      </span>
      <a-form-item label="图片" name="imageUrl">
        <UploadCustom
          :disabled="notDefaultLang"
          v-if="visible"
          v-model:imageUrl="formState.imageUrl"
        />
      </a-form-item>
      <a-form-item
        v-if="initData.formState.activityType === 1 && formState.type === 3"
      >
        <template #label="">
          <div>
            <a-checkbox v-model:checked="formState.checkValidDate"
              >任务有效期(请输入GMT+1时间)</a-checkbox
            >
          </div>
        </template>
        <a-range-picker
          v-model:value="formState.time"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          @change="changeTime"
          showTime
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-item>
      <a-form-item
        label="积分兑换规则"
        name="integralPerConsumption"
        v-if="formState.type === 2"
      >
        <div class="df aic">
          <a-input-number
            v-model:value="formState.integralPerConsumption"
            :disabled="isEdit === 'view' || notDefaultLang"
            :min="0"
          />
          <span class="ml10">积分兑换1次机会，</span>
          <span class="mr10">每日兑换上限</span>
          <a-form-item name="dailyExchangeLimit" style="margin-bottom: 0;">
            <a-input-number
              v-model:value="formState.dailyExchangeLimit"
              :min="0"
              :disabled="isEdit === 'view' || notDefaultLang"
            />
          </a-form-item>
          <span class="ml10">次</span>
        </div>
      </a-form-item>
      <a-form-item
        label="每日登录获取规则"
        name="countPerLogin"
        v-if="formState.type === 1"
      >
        <div class="df aic">
          <span>登录后获取</span>
          <a-input-number
            class="ml10 mr10"
            :min="1"
            v-model:value="formState.countPerLogin"
            :disabled="isEdit === 'view' || notDefaultLang"
          />
          <span>机会</span>
        </div>
      </a-form-item>
      <a-form-item
        label="邮件订阅获取规则"
        name="countPerSubscribe"
        v-if="formState.type === 3"
      >
        <div class="df aic">
          <span>订阅后获取</span>
          <a-input-number
            class="ml10 mr10"
            :min="1"
            v-model:value="formState.countPerSubscribe"
            :disabled="isEdit === 'view' || notDefaultLang"
          />
          <span>机会</span>
        </div>
      </a-form-item>
      <a-form-item
        label="积分消耗场景ID"
        name="scenesId"
        v-if="formState.type === 2"
      >
        <a-input-number
          :disabled="notDefaultLang"
          v-model:value="formState.scenesId"
          placeholder="请输入"
          :min="0"
          style="width: 100%;"
        />
      </a-form-item>
      <a-form-item label="每日是否清零" name="chanceNeverExpires" required>
        <a-radio-group v-model:value="formState.chanceNeverExpires">
          <a-radio :value="false">每日清零</a-radio>
          <a-radio :value="true">永久有效</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="状态" name="status">
        <a-radio-group
          v-model:value="formState.status"
          :disabled="isEdit === 'view' || notDefaultLang"
        >
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="2">禁用</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
  <a-table
    :dataSource="initData.formState.lotteryChanceObtainedWayDTOList"
    :columns="columns"
    :pagination="pagination"
    bordered
    class="mt20"
  >
    <template #bodyCell="{ column, index, record }">
      <template v-if="column.key === 'imageUrl'">
        <a-image
          :width="50"
          :src="record.imageUrl"
          :preview="false"
          fallback="data:image/png;base64,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"
        />
      </template>
      <template v-if="column.key === 'status'">
        <a-switch
          :checkedValue="1"
          :unCheckedValue="2"
          :disabled="initData.isEdit"
          v-model:checked="record.status"
        />
      </template>
      <template v-if="column.key === 'rules'">
        <span v-if="record.type !== 2">
          {{ record.type === 1 ? '登录' : '订阅' }}后获取{{
            record.type === 1 ? record.countPerLogin : record.countPerSubscribe
          }}次机会
        </span>
        <span v-else> {{ record.integralPerConsumption }}积分兑换1次机会 </span>
      </template>
      <template v-if="column.key === 'actions'">
        <a-button
          type="link"
          size="small"
          @click="handlePreview(record, 'view')"
          :disabled="initData.isEdit"
          >查看</a-button
        >
        <a-button
          type="link"
          size="small"
          @click="handlePreview(record, 'edit', index)"
          :disabled="initData.isEdit"
          >编辑</a-button
        >
        <a-button
          type="link"
          size="small"
          @click="handleDelete(index)"
          :disabled="initData.isEdit || record.status === 1"
          >删除</a-button
        >
      </template>
    </template>
  </a-table>
</template>

<script>
import { reactive, toRefs, nextTick, inject, computed, watch } from 'vue'
import UploadCustom from './Upload.vue'
import { useType } from '../hooks/useType.js'
import { message } from 'ant-design-vue'

export default {
  name: 'AddType',
  components: { UploadCustom },
  setup() {
    const initData = inject('initData')
    const state = reactive({
      subLangCode: '',
      title: '新增获取方式',
      formRef: null,
      formState: {
        type: 1,
        status: 1,
        langs: [],
        time: [],
        endTime: null,
        startTime: null,
        chanceNeverExpires: false
      },
      changeTime: (dates, dateString) => {
        state.formState.startTime = dateString[0]
        state.formState.endTime = dateString[1]
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      visible: false,
      resetData: form => ({
        name: form?.name ?? '',
        description: form?.description ?? ''
      }),
      showModal() {
        state.isEdit = 'add'

        state.visible = true

        nextTick(() => {
          state.formState.langs = []
          state.formState = {
            type: 1,
            status: 1,
            langs: initData.handleLangsLack(
              state.formState.langs,
              state.resetData()
            )
          }
          state.startWatch()
          state.subLangCode = initData.defaultLanguageCode
          if (state.disabledRadio1) {
            state.formState.type = 2
            if (state.disabledRadio2) {
              state.formState.type = 3
            } else {
              state.formState.type = 2
            }
          }
          state.formRef.resetFields()
        })
      },
      startWatch() {
        const unwatch = watch(
          () => JSON.parse(JSON.stringify(state.formState.langs)),
          (n, o) => {
            const currentLangIndex = state.formState.langs.findIndex(
              v => v.langCode === state.subLangCode
            )
            if (state.subLangCode === initData.defaultLanguageCode) {
              state.formState.langs.forEach(item => {
                if (!item?.notNamefollow) {
                  item.name = n[currentLangIndex].name
                }
                if (!item?.notDescriptionfollow) {
                  item.description = n[currentLangIndex].description
                }
              })
            } else {
              if (
                n?.[currentLangIndex]?.name !== o?.[currentLangIndex]?.name &&
                state.subLangCode
              ) {
                state.formState.langs[currentLangIndex].notNamefollow = true
              }
              if (
                n?.[currentLangIndex]?.description !==
                  o?.[currentLangIndex]?.description &&
                state.subLangCode
              ) {
                state.formState.langs[
                  currentLangIndex
                ].notDescriptionfollow = true
              }
            }
          },
          {
            deep: true
          }
        )
        return unwatch
      },
      langCodeChange() {
        state.formRef.clearValidate()
      },
      notDefaultLang: computed(
        () => state.subLangCode !== initData.defaultLanguageCode
      ),
      disabledRadio1: computed(() => {
        const leng = initData.formState.lotteryChanceObtainedWayDTOList.filter(
          e => e.type === 1
        )
        return leng.length > 0
      }),
      disabledRadio2: computed(() => {
        const leng = initData.formState.lotteryChanceObtainedWayDTOList.filter(
          e => e.type === 2
        )
        return leng.length > 0
      }),
      disabledRadio3: computed(() => {
        const leng = initData.formState.lotteryChanceObtainedWayDTOList.filter(
          e => e.type === 3
        )
        return leng.length > 0
      }),
      async handleOk() {
        if (state.isEdit === 'view') {
          state.visible = false
          return
        }
        console.log('state.formState', state.formState)
        if (state.formState.checkValidDate) {
          if (!state.formState.startTime) {
            return message.warning('请选择任务有效期')
          }
        }
        try {
          for (let v of state.formState?.langs) {
            if (!v.name || !v.description) {
              state.subLangCode = v.langCode
              await new Promise(resolve => {
                setTimeout(() => resolve(), 50)
              })
              break
            }
          }

          await state.formRef.validateFields()

          let flag = true
          for (let v of state.formState?.langs) {
            if (!v.name || !v.description) {
              message.error(
                `多语言${
                  initData.langDic.find(k => k.value === v.langCode)?.label
                }下${!v.name ? '名称' : '描述'}不能为空`
              )
              flag = false
              break
            }
          }

          if (!flag) throw { flag }

          state.visible = false
          if (state.isEdit === 'add') {
            const data = JSON.parse(
              JSON.stringify({
                ...state.formState,
                checkValidDate: state.formState.checkValidDate ? 1 : 0,
                ...state.formState?.langs?.[initData.defaultLanguageIndex]
              })
            )
            initData.formState.lotteryChanceObtainedWayDTOList.push(data)
          } else {
            const data = JSON.parse(
              JSON.stringify({
                ...state.formState,
                checkValidDate: state.formState.checkValidDate ? 1 : 0,
                ...state.formState[initData.defaultLanguageIndex]
              })
            )
            initData.formState.lotteryChanceObtainedWayDTOList[
              state.rowIndex
            ] = data
          }
          initData.formState.lotteryChanceObtainedWayDTOList.sort(
            (a, b) => a.type - b.type
          )
        } catch (errorInfo) {
          console.log('Failed:', errorInfo)
        }
      },
      rowIndex: null,
      isEdit: 'add',
      handlePreview(record, isEdit = 'edit', index = null) {
        state.formState = JSON.parse(
          JSON.stringify({
            ...record,
            langs: initData.handleLangsLack(
              record?.langs,
              state.resetData(),
              state.resetData(record)
            )
          })
        )
        state.formState.time = [record.startTime, record.endTime]
        state.subLangCode = initData.defaultLanguageCode
        state.formState.chanceNeverExpires = record.chanceNeverExpires
        if (typeof record.status === Boolean) {
          state.formState.status = record.status ? 1 : 2
        }
        state.visible = true
        state.isEdit = isEdit
        state.rowIndex = index
      },
      handleDelete(index) {
        initData.formState.lotteryChanceObtainedWayDTOList.splice(index, 1)
      },
      ...useType(),
      dataSource: [],
      pagination: {}
    })

    return {
      ...toRefs(state),
      initData
    }
  }
}
</script>
